module.exports = __webpack_public_path__ + "img/signature.713c127a.svg";